module.exports = __webpack_public_path__ + "static/eleclerc-d749908d4236b9c9cd6e5398f4ffd33b.png";